<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Users
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <div class="px-4 py-5 bg-white sm:p-6 shadow-xl rounded-md">
                    <div class="flex items-center justify-end">
                        <inertia-link
                            v-if="permissions.users.create"
                            class="rounded-md border border-transparent bg-gray-800 inline-flex items-center px-4 py-2 text-xs text-white uppercase tracking-widest font-semibold hover:bg-gray-700 transition"
                            :href="create_url">
                            Create User
                        </inertia-link>
                    </div>

                    <table v-if="users.length > 0" class="w-full mt-3">
                        <thead class="bg-gray-100">
                        <tr class="text-left border-b">
                            <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">ID</th>
                            <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">Name</th>
                            <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">Email</th>
                            <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">Partner</th>
                            <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">Created At</th>
                            <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500 whitespace-nowrap w-1">Actions</th>
                        </tr>
                        </thead>
                        <tbody class="divide-y">
                        <tr v-for="user in users">
                            <td class="p-2">{{ user.id }}</td>
                            <td class="p-2">{{ user.name }}</td>
                            <td class="p-2">{{ user.email }}</td>
                            <td class="p-2">{{ user.partner ? user.partner.name : '' }}</td>
                            <td class="p-2">{{ user.created_at }}</td>
                            <td class="p-2 whitespace-nowrap w-1">
                                <inertia-link
                                    v-if="user.permissions.edit"
                                    class="rounded-md border border-transparent bg-gray-800 inline-flex items-center px-3 py-0.5 text-xs text-white uppercase tracking-widest font-semibold hover:bg-gray-700 transition"
                                    :href="user.edit_url">Edit
                                </inertia-link>
                                <inertia-link
                                    v-if="user.permissions.impersonate"
                                    class="ml-1 rounded-md border border-transparent bg-purple-800 inline-flex items-center px-3 py-0.5 text-xs text-white uppercase tracking-widest font-semibold hover:bg-purple-600 transition"
                                    :href="user.become_url">Impersonate
                                </inertia-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div v-else class="bg-gray-100 mt-3 rounded-md py-3 px-4">
                        No users have been created yet
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import {usePage} from '@inertiajs/inertia-vue3';

    export default {
        props: ['users', 'create_url'],

        components: {
            AppLayout,
        },

        setup() {
            return {
                user: usePage().props.value.auth.user,
                permissions: usePage().props.value.auth.permissions,
            }
        },
    }
</script>
